import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-condition-check-up.reducer';

export const PatientConditionCheckUpDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientConditionCheckUpEntity = useAppSelector(state => state.patientConditionCheckUp.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientConditionCheckUpDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.detail.title">PatientConditionCheckUp</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.lastupdated}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.cursor}</dd>
          <dt>
            <span id="stageType">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.stageType">Stage Type</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.stageType}</dd>
          <dt>
            <span id="observationSummary">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.observationSummary">Observation Summary</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.observationSummary}</dd>
          <dt>
            <span id="clinicalStatus">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.clinicalStatus">Clinical Status</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.clinicalStatus}</dd>
          <dt>
            <span id="verificationStatus">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.verificationStatus">Verification Status</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.verificationStatus}</dd>
          <dt>
            <span id="conditionCategory">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.conditionCategory">Condition Category</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.conditionCategory}</dd>
          <dt>
            <span id="conditionSeverity">
              <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.conditionSeverity">Condition Severity</Translate>
            </span>
          </dt>
          <dd>{patientConditionCheckUpEntity.conditionSeverity}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.patientCondition">Patient Condition</Translate>
          </dt>
          <dd>{patientConditionCheckUpEntity.patientCondition ? patientConditionCheckUpEntity.patientCondition.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.diagnosisReport">Diagnosis Report</Translate>
          </dt>
          <dd>{patientConditionCheckUpEntity.diagnosisReport ? patientConditionCheckUpEntity.diagnosisReport.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.vitals">Vitals</Translate>
          </dt>
          <dd>{patientConditionCheckUpEntity.vitals ? patientConditionCheckUpEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.reportedBy">Reported By</Translate>
          </dt>
          <dd>{patientConditionCheckUpEntity.reportedBy ? patientConditionCheckUpEntity.reportedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.encounter">Encounter</Translate>
          </dt>
          <dd>{patientConditionCheckUpEntity.encounter ? patientConditionCheckUpEntity.encounter.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientConditionCheckUp.ipEncounter">Ip Encounter</Translate>
          </dt>
          <dd>{patientConditionCheckUpEntity.ipEncounter ? patientConditionCheckUpEntity.ipEncounter.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-condition-check-up" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-condition-check-up/${patientConditionCheckUpEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientConditionCheckUpDetail;
